// extracted by mini-css-extract-plugin
module.exports = {"container":"container___3q6NB","content":"content___2vkNe"};